<template>
    <div class="">

        <!-- This has to be converted into an AJAX call then refresh the page afterwards -->
        <div class="row">
            <div class="col-md-3">
                <div class="form-group mb-4">
                    <label for="collection_date">
                        <strong>
                            Collection Date
                        </strong>
                    </label>
                    <div class="input-group datetime collection-date">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                        <input
                            class="form-control js-flatpickers"
                            placeholder="yyyy-mm-dd"
                            id="collection_date"
                            name="collection_date"
                            v-model="collectionDate"
                            type="date"
                        >
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="delivery_date">
                        <strong>
                            Delivery Date
                        </strong>
                    </label>
                    <div class="input-group datetime collection-date">
                        <span class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </span>
                        <input
                            class="form-control js-flatpickers"
                            placeholder="yyyy-mm-dd"
                            id="collection_date"
                            name="collection_date"
                            v-model="deliveryDate"
                            type="date"
                        >
                    </div>
                </div>
            </div>
        </div>

        <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary mt-3" @click="submitBulkUpdate()">
                Update Dates
            </button>
        </div>

    </div>

</template>

<script>

import axios from 'axios';
import flatpickr from 'flatpickr';
import Swal from "sweetalert2";

export default {

    props: {
        old: {
            type: String,
            required: false
        },
    },

    data () {
        return {
            collectionDate: '',
            deliveryDate: '',
        }
    },

    mounted() {
        flatpickr('.js-date-picker', {
            altInput: true,
            altFormat: 'F j, Y',
            dateFormat: 'Y-m-d',
        });
    },

    updated() {
    },

    methods: {

        submitBulkUpdate() {

            var temp = [];
            let checked = window.jQuery('.bulk-update-checkbox:checked');

            checked.each(function(_, el) {
                let values = JSON.parse(el.value)
                temp.push(values.id);
            });

            const data = new FormData();
            data.append('collection_date', this.collectionDate);
            data.append('delivery_date', this.deliveryDate);
            data.append('ids', temp);

            axios.post(route('api.movements.jobs.bulk.update'), data)
            .then( response => {

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Dates Bulk Updated Successfully',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true
                }).then(() => {
                    window.location.reload();
                });

            }).catch( error => {

                if ( !error.response ) {
                    return;
                }

                let allErrors = '';

                if ( error.response?.data?.errors?.length > 0 ) {

                    const errorMessages = error.response.data.errors;

                    Object.entries(errorMessages).forEach(([, messages]) => {
                        messages.forEach(errorMessage => {
                            allErrors += '<p class="mb-0">' + errorMessage + '</p>';
                        });
                    });

                } else if ( error.response?.data?.message ) {
                    allErrors = error.response.data.message;
                }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Error Generating Price',
                    html: allErrors,
                    width: '600px',
                    confirmButtonText: 'Dismiss',
                    confirmButtonColor: '#dc3545 ',
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    },
                });

            });
        },

    }
}
</script>
